module.exports = __webpack_public_path__ + "img/team-bg-t1.ce8c8e3f.svg";